import React from "react";
import { X } from "lucide-react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import ModalWrapper from "../Modal";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { updateUserStatus } from "../../services/userService";

const ActivateModal = ({
  isOpen,
  onClose,
  onActivate,
  user,
  onActivateSuccess,
}) => {
  const { mutate: handleActivate, isPending } = useMutation({
    mutationFn: () => updateUserStatus(user.id, { active_status: "active" }),
    onSuccess: () => {
      toast.success("User activated successfully!");
      onClose();
      if (onActivateSuccess) onActivateSuccess();
      if (onActivate) onActivate();
    },
    onError: (error) => {
      toast.error(getErrorMessage(error, "Failed to activate user."));
    },
  });
  if (!user) return null;
  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="w-full max-w-[480px] relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-2 right-4 text-gray-[#4F535D] hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        {/* Header Icon */}
        <div className="mt-[22px] mb-6 flex justify-center">
          <img
            src="/images/icons/activate-user.svg"
            alt="activate"
            className="h-16 w-16"
          />
        </div>

        {/* Text Content */}
        <div className="mb-6 text-center">
          <h2 className="mb-3 text-2xl font-semibold text-[#0C0C0E]">
            Confirm Activation
          </h2>
          <p className="text-base text-[#7D828D] font-medium">
            Are you sure you want to activate user profile?
          </p>
        </div>

        {/* Product Preview Card */}
        <div className="mb-6 flex items-center gap-4 rounded-[14px] border border-[#ECEDEF] px-3 py-2">
          <div className="flex flex-1 flex-col">
            <span className="text-base font-medium text-[#0C0C0E]">
              {user.name}
            </span>
            <span className="text-[#7D828D] text-xs font-medium">
              {user.email}
            </span>
          </div>
          <div className="flex flex-col text-right">
            <span className="text-xs font-medium text-[#0C0C0E]">
              Date Joined
            </span>
            <span className="text-[#7D828D] text-sm font-medium">
              {user.created_at ? user.created_at.slice(0, 10) : ""}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4">
          <button
            onClick={() => handleActivate()}
            disabled={isPending}
            className="flex-1 rounded-lg h-10 bg-[#289E47] py-2 text-base font-medium text-white transition-all hover:bg-red-700 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending ? "Activating..." : "Activate"}
          </button>
          <button
            onClick={onClose}
            className="flex-1 rounded-lg h-10 border border-gray-200 bg-white py-2 text-base font-medium text-gray-700 transition-all hover:bg-gray-50 active:scale-95"
          >
            Cancel
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ActivateModal;
